module.exports = __webpack_public_path__ + "img/Tessellate06.5c029e56.png";